module.exports = __webpack_public_path__ + "img/icons_2.b4a8a1ed.png";